// 由 EB view/admin/src/router/modules/group.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const groupRouter: RouteRecordRaw =
    {
      path: `${roterPre}/group`,
      name: 'SystemGroup',
      meta: {
        icon: 'dashboard',
        title: '组合数据'
      },
      alwaysShow: true,
      component: Layout,
      children: [
        {
          path: 'list',
          name: 'SystemGroupList',
          meta: {
            title: '组合数据'
          },
          component: () => import('@/views/system/groupData/list.vue')
        },
        {
          path: 'data/:id?',
          name: 'SystemGroupData',
          meta: {
            title: '组合数据列表',
            activeMenu: '/group/list'
          },
          component: () => import('@/views/system/groupData/data.vue')
        },
        {
          path: 'topic/:id?',
          name: 'SystemTopicData',
          meta: {
            title: '专场列表',
          },
          component: () => import('@/views/system/topic/data.vue')
        },
        {
            path: 'config/:id?',
            name: 'SystemConfigData',
            meta: {
              title: '组合数据列表',
              // activeMenu: '/group/list'
            },
            component: () => import('@/views/system/groupData/data.vue')
          },
        {
            path: 'exportList',
            name: 'ExportList',
            meta: {
              title: '导出文件'
            },
            component: () => import('@/views/system/exportFile/index.vue')
          }
      ]
    }

export default groupRouter;
